import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/PelletsDataProvider";
import FormError from "../../../../../shared/forms/FormError";
import NewInput from "../../../../../shared/forms/NewInput";

const ZipcodeInput = ({
    setLocalZipcode,
    localProduct,
    setShouldCalculate = null,
    localZipcode,
    setZipcodeError,
}) => {
    const dataContext = useContext(DataContext);

    const { zipcodeError, zipcodeIsValid } = dataContext.data;
    const { checkZipcodeLoose, checkZipcodePallet } = dataContext.actions;

    const onChangeZipcode = (event) => {
        setLocalZipcode(event.target.value);
        if (event.target.value.length === 5) {
            if (localProduct === "loose") {
                checkZipcodeLoose(event.target.value);
            } else {
                checkZipcodePallet(event.target.value);
            }
        }
        setShouldCalculate && setShouldCalculate(true);
    };

    return (
        <>
            <NewInput
                className="is-small"
                placeholder="Postleitzahl"
                value={localZipcode}
                onChange={onChangeZipcode}
                validation="zipcode"
                onError={() => setZipcodeError(true)}
                onErrorSolved={() => {
                    setZipcodeError(false);
                }}
                required
                fullWidth
            />
            {!zipcodeError && !zipcodeIsValid && (
                <FormError message="Diese Postleitzahl wird nicht beliefert." />
            )}
        </>
    );
};

export default ZipcodeInput;
